import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  // align-items: center;
  height: 320px;
  width: auto;
  // border:1px solid silver;
  border-radius: 5px;
  color: black;
  padding: 10px;
  margin-left: 10px;
  cursor: pointer;
`;